import axios from "axios";

// new
const requestMortuaryRegist = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/mortuary/regist`,
    parameter
  );
};
// new
const requestMortuaryUpdate = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/mortuary/update`,
    parameter
  );
};
// New
const requestMortuaryList = () => {
  return axios.get(`${process.env.VUE_APP_APIURL}/api/app/mortuary/list`);
};
// New
const requestMortuaryRemove = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/mortuary/delete`,
    parameter
  );
};

const requestEnterRoomRegist = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/enterRoom/regist`,
    parameter
  );
};

const requestEnterList = () => {
  return axios.get(`${process.env.VUE_APP_APIURL}/api/app/enterRoom/list`);
};

// new
const requestEnterRoomUpdate = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/enterRoom/update`,
    parameter
  );
};

const requestEnterRoomRemove = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/enterRoom/delete`,
    parameter
  );
};

export {
  requestMortuaryList,
  requestMortuaryRegist,
  requestMortuaryUpdate,
  requestMortuaryRemove,
  requestEnterList,
  requestEnterRoomRegist,
  requestEnterRoomUpdate,
  requestEnterRoomRemove
};
